"use strict";
/**
 * API helper functions for Cohort endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cohortApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
exports.cohortApi = {
    /**
     * Fetch all cohorts for an organization
     */
    getCohortsByOrg: (orgId) => {
        (0, validation_1.validateId)(orgId, 'Organization ID');
        return apiClient_1.apiClient.get(`/cohort/organization/${orgId}`).then(data => data.map(apiMappers_1.mapCohort));
    },
    /**
     * Fetch a single cohort by ID
     */
    getCohortById: (cohortId) => {
        (0, validation_1.validateId)(cohortId, 'Cohort ID');
        return apiClient_1.apiClient.get(`/cohort/${cohortId}`).then(apiMappers_1.mapCohort);
    },
};
